import React, { ComponentType } from 'react';
import classNames from 'classnames';

import { CrossIcon, IconProps } from '../../assets';
import { AnimatePeek } from '../AnimatePeek';
import { Typography } from '../Typography';

import styles from './Error.module.scss';

export interface IErrorProps {
    icon?: ComponentType<IconProps>;
    title: string;
    message?: string;
    size?: 'large' | 'medium';
}

export const Error = ({ icon: Icon = CrossIcon, title, message, size = 'large' }: IErrorProps) => {
    return (
        <AnimatePeek className={classNames(styles.wrapper, styles[`size-${size}`])}>
            {Icon && <Icon className={styles.icon} />}
            <div className={styles.content}>
                <Typography className={styles.title}>{title}</Typography>
                <Typography variant="base14">{message}</Typography>
            </div>
        </AnimatePeek>
    );
};
